import { Button } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  useCloneDraftFromPublished,
  useGetCurrentDraftVersion,
} from "../../hooks/useImages";
import { ButtonWithLoading } from "../ButtonWithLoading";
import { CreateCloneImageRequest } from "../../models/Image";
import { ClientRoutes } from "../../models/ClientRoutes";

interface CreateDraftImageButtonProps {
  imageId: string;
  versionId: string;
}

export const CreateDraftImageButton = (props: CreateDraftImageButtonProps) => {
  const { imageId, versionId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: draftVersion, isLoading: loadingHasDraft } =
    useGetCurrentDraftVersion(imageId ? imageId : "");

  const { mutateAsync: cloneDraft, isPending } =
    useCloneDraftFromPublished(imageId);

  if (loadingHasDraft) {
    return <></>;
  }

  const handleCreateDraft = async () => {
    if (!versionId) {
      return;
    }
    const createdDraftRequest: CreateCloneImageRequest = {
      versionId: versionId,
    };
    const createdDraftImage = await cloneDraft(createdDraftRequest);
    navigate(
      `${ClientRoutes.MediaActivityEdit}/${createdDraftImage.versionId}`
    );
  };

  const navigateToDraft = () => {
    if (!draftVersion) {
      return;
    }
    navigate(`${ClientRoutes.MediaActivityEdit}/${draftVersion}`);
  };

  return draftVersion ? (
    <Button onClick={navigateToDraft}>{t("toDraft")}</Button>
  ) : (
    <ButtonWithLoading
      onClick={handleCreateDraft}
      isLoading={isPending}
      text={t("edit")}
      disabled={!imageId}
    />
  );
};
